import T from './types';

export const setUser = (user) => ({
  type: T.SET_USER,
  user,
});
